import clsx from 'clsx';
import React from 'react';

import '../../../../../administration/pages/ProductEditor/component/courseTeams.scss';
import { ViewTeamsMemberRow } from '@/administration/pages/Journey/pages/ViewTeams/ViewTeamsMemberRow';
import { RLearningJourneySessionDiscussionTeam } from '@/store/v2';

type ViewTeamsListProps = {
  teams: RLearningJourneySessionDiscussionTeam[];
  teamSize: number;
  onTeamSwitch: ({ newTeamId, oldTeamId, memberId }: { newTeamId: number; oldTeamId: number; memberId: number }) => void;
};

export const ViewTeamsList = ({ teams, teamSize, onTeamSwitch }: ViewTeamsListProps): React.ReactElement => {
  return (
    <div className="grid is-multiline">
      {[...teams?.values()]?.map((team, index) => (
        <div className="grid-cell grid-cell-6" key={index}>
          <nav className="panel">
            <p className={clsx('panel-heading', 'has-text-centered')}>
              Team {index + 1}
              {team?.members?.length > teamSize && (
                <>
                  <br />
                  <em className="has-text-danger">Too many team members</em>
                </>
              )}
            </p>
            {team?.members?.map((member, memberIndex) => (
              <ViewTeamsMemberRow
                member={member}
                teamIndex={index}
                key={memberIndex}
                teams={teams}
                onTeamSwitch={onTeamSwitch}
                teamId={team.id}
              />
            ))}
            {team?.members?.length < teamSize &&
              Array(teamSize - team?.members?.length)
                .fill(0)
                .map((_x, index) => (
                  <label key={index} className="panel-block" styleName="member-block member-block--free">
                    <em>Free spot</em>
                  </label>
                ))}
          </nav>
        </div>
      ))}
    </div>
  );
};
